/**
 * 接口域名的管理
 */
const base = {
    sq: 'https://storemgr.chlitina.com.cn',
    // sq: 'https://teststoremgr.chlitina.com.cn',
    bd: 'http://xxxxx22222.com/api'
}

export default base;




// WEBPACK FOOTER //
// ./src/service/base.js